import(/* webpackMode: "eager" */ "/vercel/path0/Website/app/(home)/campaigns/page.tsx")